import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { bool, element, string, node, object, oneOf, oneOfType } from 'prop-types';
import { component } from "../utils/propTypes";
import { VARIANT } from "./constants";
export var formFieldPropTypes = {
  caption: oneOfType([string, element]),
  children: node,
  hideLabel: bool,
  id: string,
  input: component,
  rootProps: object,
  label: oneOfType([string, element]).isRequired,
  required: bool,
  requiredText: oneOfType([string, element]),
  secondaryText: oneOfType([string, element]),
  variant: oneOf(Object.keys(VARIANT))
};
export var formFieldDividerPropTypes = {};
export var formFieldsetPropTypes = {
  children: node,
  disabled: bool,
  legend: oneOfType([string, element])
};